import { type FC } from 'react'

import {
  type OfferV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'
import { type SellerPromotionV2 } from '@redteclab/api/clients/composition-service-transactions'
import { IconInfo } from '@redteclab/icons'

import {
  EXPERIMENTS_TRACK_EVENT_PDP_SELLER_PROMOTION_BANNER_IMPRESSION,
  experimentsTrackEvent,
} from '../../../../experiments/eventTracking'
import { useOpenableControls } from '../../../../generic-hooks'
import { useGlobalConfigContext } from '../../../../global-config'
import { ProductSellerPromotionFlag } from '../../../../product'
import { ProductHeadGenericLabel } from '../../ProductHead/ProductHeadLabels/ProductHeadGenericLabel/ProductHeadGenericLabel'

import { ProductBuyBoxSellerPromotionModal } from './ProductBuyBoxSellerPromotionModal'

export const ProductBuyBoxSellerPromotionBadge: FC<{
  offer: OfferV11
  product: PimProductWithVariantsV1
  sellerPromotion: SellerPromotionV2
}> = ({ offer, product, sellerPromotion }) => {
  const { handleClose, handleOpen, isOpen } = useOpenableControls()
  const config = useGlobalConfigContext()

  return (
    <>
      <ProductHeadGenericLabel
        className="border-light-primary-strong bg-light-tertiary"
        data-qa-id="product-label-seller-promotion"
        onClick={() => {
          handleOpen()
          experimentsTrackEvent(
            config,
            EXPERIMENTS_TRACK_EVENT_PDP_SELLER_PROMOTION_BANNER_IMPRESSION,
          )
        }}
      >
        <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        <IconInfo className="ml-1 size-4 shrink-0" />
      </ProductHeadGenericLabel>
      <ProductBuyBoxSellerPromotionModal
        dialogTitle={
          <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        }
        isOpen={isOpen}
        offer={offer}
        onClose={handleClose}
        product={product}
      />
    </>
  )
}
